import { AuthenticationClient } from 'authing-js-sdk';
import { Environment } from 'global/environment';

export const authing = new AuthenticationClient({
  appId: Environment.AUTHING_APP_ID,
  appHost: Environment.AUTHING_DOMAIN,
});
